<template functional>
  <button
    class="button"
    :type="props.type"
    v-bind="data.attrs"
    v-on="listeners"
    :class="[
      data.staticClass, 
      data.class,
      props.class,
      $options.classes(props)
    ]"
  >
    <slot />
  </button>
</template>

<script>
export default {
  name: 'ControlButton',
  props: {
    loading: { type: Boolean, default: () => false },
    buttonStyle: { type: String, default: () => null },
    type: { type: String, default: () => 'button' },
  },
  classes(props) {
    const s = props.buttonStyle
    return {
      'is-loading': props.loading,
      'is-large-height has-text-weight-semibold is-size-4': s === '1',
      'is-large-height': s === '2',
      'is-borderless': s === '3',
      'is-outlined is-background-transparent is-mono-color is-icon-only has-padding-left-medium has-padding-right-medium':
        s === '4',
      'is-outlined is-background-transparent': s === '5',
      'is-danger is-outlined is-borderless has-margin-left-small': s === '6',
    }
  },
}
</script>
